import React from "react"
import PropTypes from "prop-types"
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material"
import { grey } from "@mui/material/colors"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { DataGridPro } from "@mui/x-data-grid-pro"

const rowPointerSx = {
  "& .MuiDataGrid-row": { cursor: "pointer" },
}

const AccordionWithDataGridPro = ({
  title,
  rows,
  dataGridProps,
  accordionDataTestId,
  dataGridDataTestId,
}) => {
  const { sx: dataGridSx, ...restDataGridProps } = dataGridProps ?? {}

  const mergedSx = Array.isArray(dataGridSx)
    ? [rowPointerSx, ...dataGridSx]
    : typeof dataGridSx === "function"
      ? theme => ({
          ...rowPointerSx,
          ...dataGridSx(theme),
        })
      : {
          ...rowPointerSx,
          ...(dataGridSx && typeof dataGridSx === "object" ? dataGridSx : {}),
        }

  return (
    <Accordion data-testid={accordionDataTestId}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{ backgroundColor: grey[300] }}
      >
        <Typography>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box
          data-testid={dataGridDataTestId}
          sx={{ width: "100%", height: 300 }}
        >
          <DataGridPro rows={rows} {...restDataGridProps} sx={mergedSx} />
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

AccordionWithDataGridPro.propTypes = {
  title: PropTypes.string.isRequired,
  rows: PropTypes.array.isRequired,
  dataGridProps: PropTypes.object,
  accordionDataTestId: PropTypes.string,
  dataGridDataTestId: PropTypes.string,
}

export default AccordionWithDataGridPro
